import { render, staticRenderFns } from "./ElementGrowthDirectionTableColumn.vue?vue&type=template&id=3f2fd2c0"
import script from "./ElementGrowthDirectionTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementGrowthDirectionTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports